export default "__VITE_ASSET__D7yw6vUQ__"